import { Pipe, PipeTransform } from "@angular/core";
import { AtmPartnerModel } from "../enums/atm-partner-model.enum";

@Pipe({ name: "atmPartnerModel" })
export class AtmPartnerModelPipe implements PipeTransform {
  transform(value: number | undefined | null): string {
    switch (value as AtmPartnerModel) {
      case AtmPartnerModel.Default:
        return "Default";
      case AtmPartnerModel.Partner:
        return "Partner";
      case AtmPartnerModel.Investor:
        return "Investor";
      default:
        return value != null ? String(value) : "—";
    }
  }
}
